import { ESystemRoles } from "@constants/SystemRoles";
import {
  EPrivateRouteType,
  IMenuList
} from "components/Layout/ManagerProLayout/utils";
import { IRoute } from "routes/types";
import { guardCheckUserRole } from "utils/guards";

export interface SidebarMenuUser {
  systemRole?: ESystemRoles;
  isi?: boolean;
  jobyfineAdmin?: boolean;
  jobyfineRecruiter?: boolean;
  jobyfineRequester?: boolean;
}

/**
 * Equivalente a `SidebarContent.checkSubRoutesRoleGuard`.
 * Devuelve `true` si ninguna ruta del grupo concede acceso al usuario.
 */
export function isSidebarMenuDenied(
  routes: IRoute[],
  user: SidebarMenuUser
): boolean {
  if (!Array.isArray(routes) || routes.length === 0) return true;

  for (const route of routes) {
    const isJobyfineRoute =
      Boolean(route?.jobyfineRecruiter) || Boolean(route?.jobyfineRequester);

    if (isJobyfineRoute && (user.jobyfineAdmin || user.isi)) {
      return false;
    }

    if (route?.jobyfineRecruiter && route?.jobyfineRequester) {
      if (user.jobyfineRecruiter || user.jobyfineRequester) return false;
    }
    if (route?.jobyfineRecruiter && user.jobyfineRecruiter) return false;
    if (route?.jobyfineRequester && user.jobyfineRequester) return false;

    if (
      guardCheckUserRole(
        route.roleGuards || [],
        user.systemRole ?? ESystemRoles.USER,
        user.isi
      )
    ) {
      return false;
    }
  }

  return true;
}

export function canShowMenuItem(
  item: IMenuList,
  user: SidebarMenuUser
): boolean {
  if (item.render === false) return false;

  if (item.type === EPrivateRouteType.ITEM && item.route) {
    return !isSidebarMenuDenied([item.route], user);
  }

  if (item.type === EPrivateRouteType.DROPDOWN && item.children?.length) {
    const routes = item.children
      .map((child) => child.route)
      .filter((route): route is IRoute => route !== undefined);
    return routes.length > 0 && !isSidebarMenuDenied(routes, user);
  }

  return false;
}
